import React, { Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
import { SmartImage } from '../common/SmartImage';
import { PayMethod } from '../../lib/data';
interface PaymentCategoryProps {
  title: string;
  description?: string;
  Icon: ComponentType<{
    className?: string;
  }>;
  methods: PayMethod[];
  open: boolean;
  onToggle: () => void;
  selected: string | null;
  onSelect: (id: string) => void;
}
export function PaymentCategory({
  title,
  description,
  Icon,
  methods,
  open,
  onToggle,
  selected,
  onSelect
}: PaymentCategoryProps) {
  return <div className="overflow-hidden rounded-xl border border-[rgba(217,217,217,0.15)] bg-[rgba(217,217,217,0.04)]" data-id="element-135" data-mp="24a9gri0iggcb">
      <button type="button" onClick={onToggle} aria-expanded={open} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-136" data-mp="2932j5z8ibcl8">
        <span className="flex items-center gap-3" data-id="element-137" data-mp="1gjvwido63lsa">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[rgba(255,113,1,0.1)]" data-id="element-138" data-mp="2are5feexduho">
            <Icon className="h-5 w-5 text-neon" data-id="element-139" data-mp="26piynue86owi" />
          </span>
          <span data-id="element-140" data-mp="26sev1eafd5iu">
            <span className="block font-semibold text-white" data-id="element-141" data-mp="21z2ii2j0sp6g">{title}</span>
            {description && <span className="mt-0.5 block text-xs text-silver/60" data-id="element-142" data-mp="1x0r9fu0juipa">
                {description}
              </span>}
          </span>
        </span>
        <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 text-silver transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-143" data-mp="1rz1xmc5i6105" />
      </button>

      <AnimatePresence initial={false} data-id="element-144" data-mp="1j1hu0wk63smd">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden" data-id="element-145" data-mp="1e1dcr4bfqtv3">
            <div className="grid grid-cols-1 gap-2 px-4 pb-4 sm:grid-cols-2" data-id="element-146" data-mp="5vhmaie7ooo">
              {methods.map(m => {
            const isSelected = selected === m.id;
            return <button key={m.id} type="button" onClick={() => onSelect(m.id)} className={`flex items-center justify-between gap-3 rounded-lg border px-3 py-2.5 text-left text-sm transition-colors ${isSelected ? 'border-neon bg-[rgba(255,113,1,0.12)] text-white' : 'border-[rgba(217,217,217,0.15)] text-silver/80 hover:border-[rgba(217,217,217,0.35)]'}`} data-id="element-147" data-mp="3ni66r8tj40ol">
                    <span className="flex min-w-0 items-center gap-2.5" data-id="element-148" data-mp="a1oujv00xk6z">
                      {m.logo && <SmartImage src={m.logo} alt={m.name} className="h-6 w-6 flex-shrink-0 rounded object-contain" data-id="element-149" data-mp="2px0h4ehd3ez8" />}
                      <span className="truncate" data-id="element-150" data-mp="2iby2999zb23r">{m.name}</span>
                    </span>
                    {isSelected && <CheckIcon className="h-4 w-4 flex-shrink-0 text-neon" data-id="element-151" data-mp="2wae7sww3umkb" />}
                  </button>;
          })}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}